import { AsyncResource } from "./utilityTypes";

const REYES_SUBSTATE_CODE = "CA_RY_ST";

// This may become an attribute on the SubState model in the future
export const isReyesSubState = (subState?: SubState | null) =>
  subState ? subState.code === REYES_SUBSTATE_CODE : false;

export interface SubState {
  id: string;
  name: string;
  code: string;
  state: AsyncResource<"state">;
  territoryIds: string[];
  relationshipNames: string[];
}
